<template>
	<ManagingSection v-if="data.id === 'img'" :splice="true">
		<ManagingBox title="타입">
			<RadioList
				:value="data.type"
				:radioList="imgTypeList"
				@input="imgTypeChange"
			/>
		</ManagingBox>
		<ManagingBox title="이미지 첨부" :xScroll="true">
			<ImgListSelector
				:value="data.imgList"
				ref="imgListSelector"
				:maxLength="imgUploaderMaxLength"
				:fixFirstImgRatio="isFixFirstImgRatio"
				@input="imgListChange"
			/>
		</ManagingBox>
		<ManagingBox title="캡션">
			<input
				:value="data.caption.text"
				placeholder="주석을 입력해주세요...(선택)"
				type="text"
				@input="captionChange"
			/>
			<RadioList
				:value="data.caption.type"
				:radioList="captionTypeList"
				@input="captionTypeChange"
			/>
		</ManagingBox>
	</ManagingSection>
	<ManagingSection v-else-if="data.id === 'txt'" :splice="true">
		<ManagingBox title="내용">
			<div class="tinymce-wrapper">
				<Tinymce
					ref="tinymce"
					:value="data.conts"
					:api-key="
						$store.state.env.NODE_ENV === 'production'
							? 'kwgaefd9w1kidf4x4803g4ja6hk8f9i5scglpw9xbdkf4jcf'
							: $store.state.env.TINYMCE_API_KEY
					"
					:init="tinymceConfig"
					@input="contsChange"
				/>
				<span v-if="sorting" class="tinymce-mask" />
			</div>
		</ManagingBox>
	</ManagingSection>
	<ManagingSection v-else-if="data.id === 'youtube'" :splice="true">
		<ManagingBox title="내용">
			<input
				:value="data.conts"
				type="text"
				@input="contsChange($event.target.value)"
			/>
		</ManagingBox>
	</ManagingSection>
	<ManagingSection v-else-if="data.id === 'pdt'" :splice="true">
		<ManagingBox title="타입">
			<RadioList
				:value="data.type"
				:radioList="pdtTypeList"
				class="pdt-type"
				@input="typeChange"
			/>
		</ManagingBox>
		<ManagingBox title="제품 검색" :xScroll="true">
			<ProductSearcher2
				:absoluteList="false"
				class="pdt-searcher"
				@change="addPdt"
			/>
			<EditorPickFormProducts
				:list="data.pdtList"
				class="pdt-list"
				@remove="removePdt"
				@sortEnd="pdtListChange"
			/>
		</ManagingBox>
	</ManagingSection>
	<ManagingSection v-else-if="data.id === 'border'" :splice="true">
		<ManagingBox title="두께">
			<RadioList
				:value="data.type"
				:radioList="borderTypeList"
				@input="typeChange"
			/>
		</ManagingBox>
	</ManagingSection>
</template>
<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import RadioList from '@/components/RadioList.vue';
	import ImgListSelector from '@/components/ImgListSelector.vue';
	import ProductSearcher2 from '@/components/ProductSearcher2.vue';
	import EditorPickFormProducts from '@/components/cast/EditorPickFormProducts.vue';
	import Tinymce from '@tinymce/tinymce-vue';

	export default {
		name: 'CastModule',
		components: {
			ManagingSection,
			ManagingBox,
			RadioList,
			ImgListSelector,
			ProductSearcher2,
			EditorPickFormProducts,
			Tinymce,
		},
		props: {
			data: {
				type: Object,
				default: {},
			},
			sorting: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				tinymceConfig: {
					width: 520,
					height: 520,
					menubar: false,
					toolbar: [
						{ name: 'styleselect', items: ['styleselect'] },
						{ name: 'forecolor', items: ['forecolor'] },
						{ name: 'bold', items: ['bold'] },
						{
							name: 'alignment',
							items: [
								'alignleft',
								'aligncenter',
								'alignright',
								'alignjustify',
							],
						},
					],
					style_formats: [
						{
							title: 'Title 1 - 28px',
							inline: 'span',
							styles: {
								'font-size': '28px',
								'line-height': '42px',
							},
						},
						{
							title: 'Title 2 - 24px',
							inline: 'span',
							styles: {
								'font-size': '24px',
								'line-height': '36px',
							},
						},
						{
							title: 'Title 3 - 20px',
							inline: 'span',
							styles: {
								'font-size': '20px',
								'line-height': '30px',
							},
						},
						{
							title: 'Heading 1 - 18px',
							inline: 'span',
							styles: {
								'font-size': '18px',
								'line-height': '27px',
							},
						},
						{
							title: 'Heading 2 - 16px',
							inline: 'span',
							styles: {
								'font-size': '16px',
								'line-height': '24px',
							},
						},
						{
							title: 'body 1 - 15px',
							inline: 'span',
							styles: {
								'font-size': '15px',
								'line-height': '22.5px',
							},
						},
						{
							title: 'body 2 - 14px',
							inline: 'span',
							styles: {
								'font-size': '14px',
								'line-height': '21px',
							},
						},
						{
							title: 'Caption - 12px',
							inline: 'span',
							styles: {
								'font-size': '12px',
								'line-height': '18px',
							},
						},
					],
					content_style: 'p { margin: 0 } body { line-height: 1.5 }',
					plugins: 'paste',
					paste_as_text: true,
				},
				imgTypeList: [
					{ id: 'single', value: '싱글' },
					{ id: 'tile', value: '타일' },
					{ id: '1:1', value: '1:1 슬라이드' },
					{ id: '4:5', value: '4:5 슬라이드' },
					{ id: '9:16', value: '9:16 슬라이드' },
					{ id: '4:1', value: '4:1 슬라이드' },
					{ id: 'fixFirstImgRatio', value: '자유 슬라이드' },
				],
				captionTypeList: [
					{ id: '400', value: 'Regular' },
					{ id: '700', value: 'Bold' },
				],
				pdtTypeList: [
					{ id: 'list', value: '리스트' },
					{ id: 'card', value: '카드' },
					{ id: 'hide', value: '미노출' },
				],
				borderTypeList: [
					{ id: '0', value: '0px' },
					{ id: '1px', value: '1px' },
				],
			};
		},
		computed: {
			imgUploaderMaxLength() {
				return this.data.id === 'img' && this.data.type === 'single'
					? 1
					: null;
			},
			imgValidation() {
				const imgType = this.data.type;
				return this.data.id === 'img' &&
					(imgType === 'tile' ||
						imgType === '1:1' ||
						imgType === '4:5' ||
						imgType === '9:16' ||
						imgType === '4:1')
					? {
							type: 'ratio',
							value: imgType === 'tile' ? '1:1' : imgType,
						}
					: {};
			},
			isFixFirstImgRatio() {
				return this.data.type === 'fixFirstImgRatio';
			},
		},
		mounted() {
			if (this.isFixFirstImgRatio) {
				const firstImgRatio = this.data.realType;
				this.$refs.imgListSelector.firstImgRatio = firstImgRatio;
				this.$emit('input', {
					...this.data,
					realType: firstImgRatio,
				});
			}
		},
		methods: {
			emitData(changes) {
				this.$emit('input', {
					...this.data,
					...changes,
				});
			},
			imgTypeChange(type) {
				this.$refs.imgListSelector.init();
				this.emitData({
					type,
					imgList: [],
				});
			},
			imgListChange(imgList) {
				const payload = { imgList };

				if (this.isFixFirstImgRatio) {
					payload.realType = this.$refs.imgListSelector.firstImgRatio;
				}

				this.emitData(payload);
			},
			captionChange(e) {
				this.emitData({
					caption: {
						...this.data.caption,
						text: e.target.value,
					},
				});
			},
			captionTypeChange(type) {
				this.emitData({
					caption: {
						...this.data.caption,
						type,
					},
				});
			},
			contsChange(conts) {
				this.emitData({ conts });
			},
			typeChange(type) {
				this.emitData({ type });
			},
			addPdt(pdt) {
				if (!pdt) return;
				if (
					this.data.pdtList.some(
						item => item.idProduct === pdt.idProduct
					)
				) {
					alert('이미 추가된 제품 입니다');
					return;
				}
				this.emitData({
					pdtList: [
						...this.data.pdtList,
						{
							...pdt,
							image: pdt.filePath,
							title: `[${pdt.idProduct}/${pdt.brandTitle}] ${pdt.productTitle}`,
						},
					],
				});
			},
			removePdt(idPdt) {
				const newPdtList = [...this.data.pdtList];
				newPdtList.splice(
					newPdtList.findIndex(item => item.idProduct === idPdt),
					1
				);
				this.emitData({ pdtList: newPdtList });
			},
			pdtListChange(pdtList) {
				this.emitData({ pdtList });
			},
		},
	};
</script>
<style lang="scss" scoped>
	.tinymce-wrapper {
		position: relative;
	}

	.tinymce-mask {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	.pdt-type::v-deep
		.bundle__list-item:nth-child(3)
		.radio-box__text--checked {
		color: #ff451d;
	}

	.pdt-searcher {
		z-index: 100;
	}

	.pdt-list {
		margin-top: 26px;
		width: 100%;
	}
</style>
